// Vendors
import React from 'react';
import { useSelector } from 'react-redux';

// Routes
import { RoutesPublic } from '../../../routes';

// Components
import PublicLayoutBase from '../PublicLayoutBase';
import { TxAlert, TxAlertType } from 'texkit-ui/components';

import { NavbarPublic, Trans, Footer } from '../../../components';

function parseAlert(alert) {
  const {
    type,
    info,
    info: { title, message },
  } = alert;

  let errorType;
  switch (alert.type) {
    case 'info':
      errorType = TxAlertType.Info;
      break;
    case 'danger':
      errorType = TxAlertType.Error;
      break;
    case 'warning':
    default:
      errorType = TxAlertType.Warning;
  }

  return (
    <TxAlert
      type={errorType}
      heading={
        <Trans
          file={title.file || title.type || 'Alerts' || type}
          id={title.id}
          fallback="Something went wrong. Please contact your administrator"
        />
      }
    >
      <Trans
        file={message.file || title.type || 'Alerts' || type}
        id={message.id}
        fallback="Something went wrong. Please contact your administrator"
      />
    </TxAlert>
  );
}

function TermsConditionsLayout() {
  const { alert } = useSelector(state => state);

  return (
    <PublicLayoutBase>
      {alert.info && parseAlert(alert)}
      <NavbarPublic />
      <div className="layout">
        <RoutesPublic />
        <Footer />
      </div>
    </PublicLayoutBase>
  );
}

export default TermsConditionsLayout;
